<template>
  <div>
    <v-dialog v-model="getGlobalConfirmDelete" persistent max-width="500">
      <v-card>
        <v-card-title
          :style="{'color':getThemeColor}"
          class="text-h5 lighten-2"
        >Confirm Delete</v-card-title>

        <v-card shaped elevation="12" outlined class="mx-10">
          <v-container>
            <v-row>
              <v-btn
                rounded
                class="mt-4 mb-10 mx-auto"
                :style="{'background-color':getThemeColor,'color':'white'}"
                @click="deleteConfirmed(true)"
              >
                <v-icon left>mdi-times</v-icon>
                Delete {{item}}
              </v-btn>
            </v-row>
          </v-container>
        </v-card>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="deleteConfirmed(false)">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      default: "Item(s)"
    }
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getGlobalConfirmDelete() {
      return this.$store.getters.getGlobalConfirmDelete;
    }
  },
  methods: {
    deleteConfirmed(choice) {
      this.$emit("delete-confirmed", choice);
      this.$store.commit("setGlobalConfirmDelete", false);
    }
  }
};
</script>

<style>
</style>